import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { WMHD_PATH, WMHD_THEME, isWmhdSeason } from '../content/worldMentalHealthDay.meta';

// A small card for the World Mental Health Day page. Always on About; elsewhere
// (seasonOnly) only in October.
export default function WmhdCard({ isNight, seasonOnly = false, className = '' }: { isNight: boolean; seasonOnly?: boolean; className?: string }) {
  if (seasonOnly && !isWmhdSeason()) return null;
  return (
    <Link
      to={WMHD_PATH}
      className={`${className} group relative overflow-hidden flex items-center gap-4 rounded-3xl border p-5 text-left transition-all hover:-translate-y-0.5 ${
        isNight ? 'border-white/10 bg-[linear-gradient(135deg,#0a2a47,#05162b)] text-white' : 'border-black/5 bg-[linear-gradient(135deg,#dbeefc,#fff7e0)] text-black shadow-sm hover:shadow-md'
      }`}
    >
      <span className="shrink-0 w-12 h-12 rounded-full flex items-center justify-center text-2xl bg-[#f2c14e]/15 ring-1 ring-[#f2c14e]/40" style={{ boxShadow: '0 0 24px rgba(242,193,78,0.35)' }} aria-hidden="true">🌻</span>
      <span className="flex-1 min-w-0">
        <span className="block text-[0.625rem] uppercase tracking-[0.25em] opacity-60">Resources · every year on 10 October</span>
        <span className="block mt-0.5 text-xl leading-tight" style={{ fontFamily: "'Instrument Serif', serif" }}>World Mental Health Day</span>
        <span className="block text-xs opacity-70 mt-1 leading-relaxed">“{WMHD_THEME}”. Facts, small rituals, films, books and songs, and kind people to talk to.</span>
      </span>
      <ArrowRight size={15} className="shrink-0 opacity-40 transition-transform group-hover:translate-x-0.5" />
    </Link>
  );
}
